import { ExtensionAdditionalData } from "@/app/api/extension/extensionSchemas";

export enum BaseFormField {
  // Personal details
  Gender = 'gender',
  FirstName = 'firstName',
  LastName = 'lastName',
  DateOfBirth = 'dateOfBirth',

  // Contact information
  CountryCode = 'countryCode',
  MobileNumber = 'mobileNumber',
  Email = 'email',

  // Address information
  PostalCode = 'postalCode',
  StreetName = 'streetName',
  HouseNumber = 'houseNumber',
  City = 'city',
  Country = 'country',

  //Start date information
  StartDate = "startDate",

  // Billing information
  IBAN = 'iban',

  // Checkboxes
  TermsAndConditions = 'termsAndConditions',
  // Email-marketing consent (NEWSLETTER category, EMAIL/LETTER/TEXT_MESSAGE channels)
  ReceiveNewsletter = 'receiveNewsletter',
  // Phone/telemarketing consent (NEWSLETTER category, PHONE channel)
  PhoneConsent = 'phoneConsent',
}

export enum TrailFormField {
  Day = 'day',
  Time = 'time',
}

export interface BaseFormValues {
  // Personal details
  [BaseFormField.Gender]: string;
  [BaseFormField.FirstName]: string;
  [BaseFormField.LastName]: string;
  [BaseFormField.DateOfBirth]: string;

  // Contact information
  [BaseFormField.CountryCode]: string;
  [BaseFormField.MobileNumber]: string;
  [BaseFormField.Email]: string;

  // Address information
  [BaseFormField.PostalCode]: string;
  [BaseFormField.StreetName]: string;
  [BaseFormField.HouseNumber]: string;
  [BaseFormField.City]: string;
  [BaseFormField.Country]: string;

  //Start date information
  [BaseFormField.StartDate]: string;

  // Billing information
  [BaseFormField.IBAN]?: string;

  // Checkboxes
  [BaseFormField.TermsAndConditions]: boolean;
  [BaseFormField.ReceiveNewsletter]: boolean;
  [BaseFormField.PhoneConsent]: boolean;
}

export type RegistrationFormField = BaseFormField;
export type RegistrationFormValues = BaseFormValues & {
  preuseDate?: string;
};
export type ExtensionFormValues = Pick<BaseFormValues, BaseFormField.TermsAndConditions | BaseFormField.ReceiveNewsletter> & ExtensionAdditionalData;

export interface TrailFormValues extends BaseFormValues {
  [TrailFormField.Day]: string;
  [TrailFormField.Time]: string;
}

export enum ExtensionVerificationForm {
  HomeClub = 'homeClub',
  DateOfBirth = 'dateOfBirth',
  MembershipNumber = 'membershipNumber',
}

export type HomeClubType = {
  studioName: string;
  clubId: string;
  city: string;
  countryCode: string;
};

export interface ExtensionVerificationFormTypes {
  [ExtensionVerificationForm.HomeClub]: HomeClubType | null;
  [ExtensionVerificationForm.DateOfBirth]: string;
  [ExtensionVerificationForm.MembershipNumber]: string;
}
